import React from 'react'
import Search from './Search'

class HeaderWithSearch extends React.Component {
  render () {
    return (
      <div style={styles.content}>
        <div style={styles.top}>
          <div style={styles.titleContent}>
            <span style={styles.title}>{this.props.title}</span>
          </div>
          <Search
            getKeySearch={this.props.getKeySearch}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    height: '100px',
    marginTop: '5px'
  },
  top: {
    height: '50px'
  },
  titleContent: {
    float: 'left'
  },
  title: {
    float: 'left',
    marginTop: '3px',
    marginLeft: '14px',
    fontSize: '32px',
    color: '#FFFFFF',
    fontWeight: 321,
    fontStyle: 'normal'
  }
}

export default HeaderWithSearch
